import { Action } from './Action.js';
/**
 * @class AddToTrend
 * @extends Action
 * @classdesc Действие добавить на тренд
 * */
export class AddToTrend extends Action {	
	execute(context) {
        const trends = document.querySelectorAll('ms-trend')
        if(trends.length){
            if(trends.length === 1){
                trends[0].addToTrend(this.data)
            } else {
                let parentElement = context.currentTarget.parentElement
                let done = false
                while(parentElement !== document.body && !done){
                    const trends = parentElement.querySelectorAll('ms-trend')
                    if(trends.length){
                        done = true
                        trends[0].addToTrend(this.data)
                    }
                    parentElement = parentElement.parentElement
                }
            }
        } else {
            $ns.add({
                type: "warning",
                time: new Date().toLocaleString(),
                title: `Ошибка действия "Добавить на тренд"`,
                text: `Тренд не найден`,
            });
        }
	}
    get data(){
        return {PenName: this.Pen?.value, Title: this.Title?.value}
    }
}